import { makeReducerPermission } from "../../index";

export const resendInviteCodePermission = makeReducerPermission({
  reducerName: "resendInviteCode",
});
